import { render, staticRenderFns } from "./RevenuePerSupplier.vue?vue&type=template&id=42a10b23&scoped=true&"
import script from "./RevenuePerSupplier.vue?vue&type=script&lang=js&"
export * from "./RevenuePerSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a10b23",
  null
  
)

export default component.exports